import { ColumnDetails } from 'src/app/models/columnDetails.model';
import { isCustomFieldKey, parseDefaultValue } from './custom-field-helpers';

const SCALAR_DEFAULT_TYPES: ReadonlySet<string> = new Set(['string', 'number', 'enum', 'boolean', 'object']);

export function applyFieldConfigDefaults<T>(
  entity: T,
  columnDetails: { [property: string]: ColumnDetails } | null | undefined
): string[] {
  const target = entity as Record<string, unknown>;
  const filledKeys: string[] = [];
  Object.entries(columnDetails ?? {}).forEach(([key, config]) => {
    if (config.defaultValue === null || config.defaultValue === undefined || config.defaultValue === '') return;
    if (!SCALAR_DEFAULT_TYPES.has(config.type) || config.isVisibleOnDialog === false || isCustomFieldKey(key)) return;
    if (target[key] !== null && target[key] !== undefined) return;
    const value = parseDefaultValue(config.defaultValue, config.type);
    if (value === null) return;
    target[key] = value;
    filledKeys.push(key);
  });
  return filledKeys;
}
